import * as contentful from 'contentful'

export default !!process.env.CONTENTFUL_API_KEY
  ? contentful.createClient({
      space: process.env.CONTENTFUL_SPACE_ID,
      accessToken: process.env.CONTENTFUL_API_KEY,
      host: process.env.CONTENTFUL_HOST,
    })
  : undefined
